export enum OrderItemType {
  ACCOMMODATION = 'accommodation',
}

export const UpsellableOrderItemTypes = [
  OrderItemType.ACCOMMODATION,
]
